import { useMount } from 'ahooks';
import { Checkbox } from 'antd';
import FormField from 'components/FormField';
import { useTranslate } from '@tolgee/react';
import { isReturnTradeScenarioType } from '../config';
import { FV } from './share';
import { DisabledProps } from '../TaskForm/share';

export interface ReturnTypeFieldProps {
  scenarioType: Marketing.AllScenarioType;
}

function ReturnTypeField(props: ReturnTypeFieldProps & DisabledProps) {
  const { scenarioType, disabled } = props;

  const { t } = useTranslate();

  if (!isReturnTradeScenarioType(scenarioType)) {
    return null;
  }

  return (
    <FormField<Required<FV>['returnTradeConfig']['returnType']>
      name="returnTradeConfig.returnType"
      required
      label={t('aide.申请售后类型')}
      validate={(returnType = []) =>
        returnType.length > 0 ? undefined : t('aide.请选择申请售后类型')
      }
    >
      {({ field: { value, onChange, ...others } }) => {
        const supportReturnRefund = ![
          'RETURN_TRADE_NOT_RECEIPT',
          'RETURN_TRADE_PRODUCT_NOT_IN_TIME',
        ].includes(scenarioType);

        // eslint-disable-next-line react-hooks/rules-of-hooks
        useMount(() => {
          if (!value) {
            onChange(supportReturnRefund ? ['ONLY_REFUND', 'RETURN_REFUND'] : ['ONLY_REFUND']);
          }
        });

        return (
          <Checkbox.Group
            disabled={disabled}
            value={value}
            onChange={(value) => onChange(value as any)}
            {...others}
          >
            <Checkbox value="ONLY_REFUND">{t('aide.仅退款')}</Checkbox>
            {supportReturnRefund && <Checkbox value="RETURN_REFUND">{t('aide.退货退款')}</Checkbox>}
          </Checkbox.Group>
        );
      }}
    </FormField>
  );
}

export default ReturnTypeField;
